
/**
 * 导出当前仓库 npm 版本
 */

// TODO: this is special because it gets imported during pub.
const version = '0.3.304-hotfix10';

export default version;
